import { useSensor, useSensors, MouseSensor, TouchSensor } from "@dnd-kit/core";

export const useBlockFolderDragKit = () => {
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: 200,
      tolerance: 8,
    },
  });

  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: 8,
    },
  });

  const sensors = useSensors(touchSensor, mouseSensor);

  return { sensors };
};

export default useBlockFolderDragKit;
